<template>
  <div class="terminal terminal-tabbed">
    <terminal-toolbar v-if="showToolbar" :title="username">
      <div class="terminal-tabs">
        <ul>
          <li
            v-for="(name, index) in tabNames"
            :key="index"
            @click="switchTab(name)"
            :class="{'is-active':currentTabName==name}"
          >
            <a>
              <span>{{name}}</span>
              <span class="toolbar-icon tab-close">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </terminal-toolbar>

    <!--TODO: Using custom refs feels hacky -->
    <terminal-body
      v-for="(name, index) in tabNames"
      :key="index"
      :ref="buildTabRef(name)"
      v-show="currentTabName==name"
      :commands="tabs[name].commands"
      :autoStart="autoStart"
      :typeCharDelay="typeCharDelay"
      :username="username"
      :promptIcon="promptIcon"
    ></terminal-body>
  </div>
</template>
<script>
import TerminalToolbar from "./TerminalToolbar";
import TerminalBody from "./TerminalBody";

export default {
  components: { TerminalBody, TerminalToolbar },
  props: {
    promptIcon: String,
    showToolbar: { default: true },
    username: {
      default: "ben@steadbytes"
    },
    tabs: Object,
    startTab: String,
    typeCharDelay: {
      default: 250
    },
    autoStart: {
      default: true
    }
  },
  data() {
    return {
      currentTabName: this.startTab
    };
  },
  computed: {
    tabNames() {
      return Object.keys(this.tabs);
    },
    currentTabRef() {
      const ref = this.buildTabRef(this.currentTabName);
      return this.$refs[ref][0];
    }
  },
  methods: {
    buildTabRef(name) {
      return "tab-" + name;
    },
    switchTab(name) {
      this.currentTabName = name;
      this.startCurrent();
    },
    startCurrent() {
      this.currentTabRef.start();
    },
    stopCurrent() {
      this.currentTabRef.stop();
    }
  }
};
</script>
